import React, { useState } from 'react';
import ReactDOM from 'react-dom'
import { useNavigate } from "react-router-dom";

export default function DashboardHeader() {

  const user = JSON.parse(localStorage.getItem('user'));
  const [userInfo, setUserInfo] = useState([]);
  const navigate = useNavigate();

  function signOut(e) {
    e.preventDefault();
    e.stopPropagation();
    localStorage.setItem('user', null)
    localStorage.setItem('isLoggedIn', '0')
    navigate('/');
  }

  return (
    <nav className="navbar default-layout col-lg-12 col-12 p-0 fixed-top d-flex align-items-top flex-row">
      <link href="assets/css/styles.css" rel="stylesheet"></link>
      <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-start">
        <div className="me-3">
          <button className="navbar-toggler navbar-toggler align-self-center" type="button" data-bs-toggle="minimize">
            <span className="icon-menu"></span>
          </button>
        </div>
        <div>
          <a className="navbar-brand brand-logo" href="#">
            <img src={process.env.PUBLIC_URL + 'assets/Dash/images/logo.png'} alt="logo" />
          </a>
          <a className="navbar-brand brand-logo-mini" href="#">
            <img src={process.env.PUBLIC_URL + 'assets/Dash/images/logo.png'} alt="logo" />
          </a>
        </div>
      </div>
      <div className="navbar-menu-wrapper d-flex align-items-top">
        <ul className="navbar-nav">
          <li className="nav-item font-weight-semibold d-none d-lg-block ms-0">
            <h1 className="welcome-text">Welcome, <span className="text-black fw-bold">{user && user[0].First_Name}</span></h1>
            <h3 className="welcome-sub-text">Let's explore the progress</h3>
          </li>
        </ul>
        <ul className="navbar-nav ms-auto">

          <li className="nav-item">
            <form className="search-form" action="#">
              <i className="icon-search"></i>
              <input type="search" className="form-control" placeholder="Search Here" title="Search here" />
            </form>
          </li>
          {/* <li className="nav-item dropdown"> 
              <a className="nav-link count-indicator" id="countDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                <i className="icon-bell"></i>
                <span className="count"></span>
              </a>
              <div className="dropdown-menu dropdown-menu-right navbar-dropdown preview-list pb-0" aria-labelledby="countDropdown">
                <a className="dropdown-item py-3">
                  <p className="mb-0 font-weight-medium float-left">You have 7 unread mails </p>
                  <span className="badge badge-pill badge-primary float-right">View all</span>
                </a>
                <div className="dropdown-divider"></div>
                <a className="dropdown-item preview-item">
                  <div className="preview-thumbnail">
                    <img src={process.env.PUBLIC_URL + 'assets/Dash/images/faces/face10.jpg'} alt="image" className="img-sm profile-pic"/>
                  </div>
                  <div className="preview-item-content flex-grow py-2">
                    <p className="preview-subject ellipsis font-weight-medium text-dark">Marian Garner </p>
                    <p className="fw-light small-text mb-0"> The meeting is cancelled </p>
                  </div>
                </a>
                <a className="dropdown-item preview-item">
                  <div className="preview-thumbnail">
                    <img src={process.env.PUBLIC_URL + 'assets/Dash/images/faces/face12.jpg'} alt="image" className="img-sm profile-pic"/>
                  </div>
                  <div className="preview-item-content flex-grow py-2">
                    <p className="preview-subject ellipsis font-weight-medium text-dark">David Grey </p>
                    <p className="fw-light small-text mb-0"> The meeting is cancelled </p>
                  </div>
                </a>
                <a className="dropdown-item preview-item">
                  <div className="preview-thumbnail">
                    <img src={process.env.PUBLIC_URL + 'assets/Dash/images/faces/face1.jpg'} alt="image" className="img-sm profile-pic"/>
                  </div>
                  <div className="preview-item-content flex-grow py-2">
                    <p className="preview-subject ellipsis font-weight-medium text-dark">Travis Jenkins </p>
                    <p className="fw-light small-text mb-0"> The meeting is cancelled </p>
                  </div>
                </a>
              </div>
            </li> */}
          <li className="nav-item dropdown d-none d-lg-block user-dropdown">
            <a className="nav-link" id="UserDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
              <i className="icon-user"></i>
            </a>
            <div className="dropdown-menu dropdown-menu-right navbar-dropdown" aria-labelledby="UserDropdown">
              <div className="dropdown-header text-center">
                <i className="icon-user customusericon"></i>
                <p className="mb-1 mt-3 font-weight-semibold">{user && user[0].First_Name}</p>
                <p className="fw-light text-muted mb-0">{user && user[0].Email}</p>
              </div>
              <a className="dropdown-item" href='/user-detail'><i className="dropdown-item-icon mdi mdi-account-outline text-primary me-2"></i> My Profile</a>
              <a className="dropdown-item" href='/plans'><i className="dropdown-item-icon mdi mdi-crown text-primary me-2"></i> Plans</a>
              <a className="dropdown-item" href='/invoice'><i className="dropdown-item-icon mdi mdi-folder-outline text-primary me-2"></i> Invoice</a>
              <a className="dropdown-item comingsoontag"><i className="dropdown-item-icon mdi mdi-message-text-outline text-primary me-2"></i> Messages</a>
              <a className="dropdown-item comingsoontag"><i className="dropdown-item-icon mdi mdi-calendar-check-outline text-primary me-2"></i> Activity</a>
              <a className="dropdown-item comingsoontag"><i className="dropdown-item-icon mdi mdi-help-circle-outline text-primary me-2"></i> FAQ</a>
              <a className="dropdown-item" onClick={signOut}
              ><i className="dropdown-item-icon mdi mdi-power text-primary me-2"></i>Sign Out</a>
            </div>
          </li>
        </ul>
        <button className="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button" data-bs-toggle="offcanvas">
          <span className="mdi mdi-menu"></span>
        </button>
      </div>
    </nav>
  )
}